import { getType } from '@anm/helpers/saga/typesafe-actions';
import { Reducer } from 'redux';

import { initialVideoFolderState } from '..';
import { clearNewFolder, createFolderAsync } from '../../actions';
import { addNewFolder } from '../../helpers';
import { VideoFolderActions } from '../../types';

const newFolderReducer: Reducer<typeof initialVideoFolderState, VideoFolderActions> = (
  state = initialVideoFolderState,
  action
) => {
  switch (action.type) {
    case getType(clearNewFolder): {
      return {
        ...state,
        newFolder: {
          ...state.newFolder,
          data: null
        }
      };
    }
    case getType(createFolderAsync.request): {
      const params = action.payload;
      return {
        ...state,
        newFolder: {
          ...state.newFolder,
          params,
          error: null,
          isError: false,
          isPending: true
        }
      };
    }
    case getType(createFolderAsync.success): {
      const { data, folderTree, newFolder: newFolderState } = state;
      const newFolder = action.payload;

      const currentFolders =
        data!.id === newFolderState!.params!.parentId ? [newFolder, ...data!.folders] : [...data!.folders];

      return {
        ...state,
        data: { ...data!, folders: currentFolders },
        newFolder: {
          ...state.newFolder,
          data: newFolder,
          isPending: false
        },
        folderTree: {
          ...state.folderTree,
          data: addNewFolder({
            newFolder,
            folderTree: folderTree.data!,
            parentId: newFolderState!.params!.parentId
          }),
          isError: false,
          isPending: false
        }
      };
    }
    case getType(createFolderAsync.failure): {
      const error = action.payload;

      return {
        ...state,
        newFolder: {
          ...state.newFolder,
          error,
          isError: true,
          isPending: false
        }
      };
    }
    default:
      return state;
  }
};

export default newFolderReducer;
